import { switchTheme, intToTheme, themeToInt } from "@/common/utils.theme";

import eventAction from "@/store/eventAction";

// state
const state = {
  active: localStorage.getItem("theme")
    ? localStorage.getItem("theme")
    : "light"
};

// getters
const getters = {};

// actions
const actions = {
  switchTheme({ commit, state, dispatch }) {
    commit("SWITCH_THEME");
    dispatch(
      "events/emit",
      {
        action: eventAction.user.theme.change,
        data: themeToInt(state.active)
      },
      {
        root: true
      }
    );
  },

  handleEvent({ commit }, event) {
    switch (event.action) {
      case eventAction.user.theme.change: {
        commit("SET_THEME", event.data);
        break;
      }
    }
  }
};

// mutations
const mutations = {
  SWITCH_THEME(state) {
    state.active = switchTheme(state.active);
  },
  SET_THEME(state, theme) {
    const parsed = parseInt(theme);
    if (isNaN(parsed)) {
      state.active = theme;
    } else {
      state.active = intToTheme(parsed);
    }
    localStorage.setItem("theme", state.active);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
